const labelPrintOrderSettingName = 'LabelPrintOrder';
const gridOrderingSetting = 'ShipSequence asc';

export const hasGridOrderingEnabledForBulkPrint = (sellerSettings) => {
  if (sellerSettings) {
    const labelPrintOrderSetting = sellerSettings[labelPrintOrderSettingName];
    return labelPrintOrderSetting.indexOf(gridOrderingSetting) >= 0;
  }
};
